import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "fill-height bg_auth",
  style: {}
}
const _hoisted_2 = ["height", "width"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_flex = _resolveComponent("v-flex")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_center = _resolveComponent("center")!
  const _component_v_layout = _resolveComponent("v-layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_layout, {
      wrap: "",
      class: "login"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_center, {
          class: _normalizeClass(!_ctx.$vuetify.display.mobile ? 'login_card' : 'login_card_mobile')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_flex, {
              xs12: "",
              class: "text-center"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: "/img/bobbee_logo_3.png",
                  height: !_ctx.$vuetify.display.mobile ? '100vh' : '',
                  width: !_ctx.$vuetify.display.mobile ? '' : '200vw'
                }, null, 8, _hoisted_2)
              ]),
              _: 1
            }),
            (_ctx.user && _ctx.activeToken)
              ? (_openBlock(), _createBlock(_component_v_flex, {
                  key: 0,
                  xs6: "",
                  class: "align-center"
                }, {
                  default: _withCtx(() => [
                    _cache[7] || (_cache[7] = _createElementVNode("h3", null, "Réinitialiser votre mot de passe", -1)),
                    _createVNode(_component_v_form, {
                      ref: "form",
                      modelValue: _ctx.valid,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.valid) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          rounded: "",
                          required: "",
                          type: "password",
                          rules: [
                                () => _ctx.password.length > 0 || 'empty password',
                                () =>
                                    _ctx.password === _ctx.pwdConfirmation ||
                                    !_ctx.pwdConfirmation.length > 0 ||
                                    'Passwords does not match',
                            ],
                          onKeyup: _withKeys(_ctx.resetPassword, ["enter"]),
                          placeholder: "Nouveau mot de passe",
                          modelValue: _ctx.password,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event))
                        }, null, 8, ["rules", "onKeyup", "modelValue"]),
                        _createVNode(_component_v_text_field, {
                          rounded: "",
                          required: "",
                          type: "password",
                          rules: [
                                () => _ctx.pwdConfirmation.length > 0 || 'empty password',
                                () =>
                                    _ctx.password === _ctx.pwdConfirmation ||
                                    !_ctx.password.length > 0 ||
                                    'Passwords does not match',
                            ],
                          onKeyup: _withKeys(_ctx.resetPassword, ["enter"]),
                          placeholder: "Confirmer votre mot de passe",
                          modelValue: _ctx.pwdConfirmation,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pwdConfirmation) = $event))
                        }, null, 8, ["rules", "onKeyup", "modelValue"]),
                        _createVNode(_component_v_btn, {
                          rounded: "",
                          color: "primary",
                          width: "80%",
                          elevation: "0",
                          onClick: _ctx.resetPassword,
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                            _createTextVNode("Modifier")
                          ])),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_v_alert, {
                      type: "success",
                      "model-value": _ctx.isPasswordModified
                    }, {
                      default: _withCtx(() => [
                        _cache[5] || (_cache[5] = _createTextVNode("Votre mot de passe a bien été modifié ")),
                        _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                        _createVNode(_component_router_link, { to: '/login' }, {
                          default: _withCtx(() => _cache[4] || (_cache[4] = [
                            _createTextVNode("Se connecter")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model-value"])
                  ]),
                  _: 1
                }))
              : (_ctx.user)
                ? (_openBlock(), _createBlock(_component_v_flex, { key: 1 }, {
                    default: _withCtx(() => [
                      _cache[9] || (_cache[9] = _createElementVNode("p", null, "Le lien de reinitialisation a expiré", -1)),
                      _createVNode(_component_router_link, { to: '/login' }, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createTextVNode("Retourner à la page de connection")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    })
  ]))
}